// @flow

import React from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import type { Node } from 'react'
import Text from '../Sections/Text'
import useMentionsAndHashtags from '../useMentionsAndHashtags'

type CaptionProps = {
    caption?: string,
    usePadding: boolean,
    children?: Node,
    hashtags: string[]
}
const CaptionContainer: ReactComponentStyled<{}> = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  padding-top: ${(props) => props.usePadding ? '1%' : 'auto'}
  margin: 2%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: 1200px) {
    padding-right: 22%;
    padding-left: 22%;
  }
  @media (min-width: 825px) and (max-width: 1199px) {
    padding-right: 10%;
    padding-left: 10%;
  }
  @media (max-width: 411px) {
    padding-top: ${(props) => props.usePadding ? '2%' : 'auto'}
  }
`
CaptionContainer.displayName = 'CaptionContainer'

function Caption ({ caption, usePadding, hashtags, children }: CaptionProps) {
  const { parseMentionsAndHashtags } = useMentionsAndHashtags()

  let childrenBody = ''
  if (caption) {
    childrenBody = <Text size='P' fontColor='black' align='justify' text={parseMentionsAndHashtags(caption, hashtags)} />
  } else {
    childrenBody = children
  }
  return (
    <CaptionContainer usePadding={usePadding}>
      {childrenBody}
    </CaptionContainer>
  )
}

export default Caption
